// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UIgfo","col":"styles_col__1QUaM"};